/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import data from '../../data';

const useStyles = makeStyles((theme) => ({
  headerSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    '& h1': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '2.4rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '2rem',
      },
    },
  },
  logo: {
    maxWidth: 202,
    height: 'auto',
    width: '60%',
    marginLeft: '4px',
    imageRendering: 'crisp-edges',// eslint-disable-line
    imageRendering: '-moz-crisp-edges',// eslint-disable-line
    imageRendering: '-o-crisp-edges',// eslint-disable-line
    imageRendering: '-webkit-optimize-contrast',// eslint-disable-line
  },
  link: {
    fontSize: '1.2rem',
    paddingRight: 10,
    textDecoration: 'underline',
    color: '#404040',
    '&:hover': {
      color: '#636363',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
  selectLanguage: {
    fontWeight: 400,
    fontSize: 16,
  },
  formControl: {
    maxWidth: 120,
    marginBottom: 10,
  },
}));

const Header = ({ lang, handleLangChange }) => {
  const handleChange = (event) => {
    handleLangChange(event.target.value);
  };
  const location = useLocation();
  const classes = useStyles();
  return (
    <Box className={classes.header}>
      <Container maxWidth="lg">
        <Box className={classes.headerSection}>
          <img src="./assets/qlik-logo.png" alt="Qlik logo" className={classes.logo} />
          <FormControl className={classes.formControl}>
            <Select
              id="english-select"
              disableUnderline
              value={lang}
              onChange={handleChange}
              defaultValue={1}
              className={classes.selectLanguage}
            >
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="jp">Japanese</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box className={classes.headerSection}>
          <Typography variant="h1">{lang === 'jp' ? data.jp.header.appName : data.en.header.appName}</Typography>
          <nav>
            <Link to={{ pathname: location.pathname === '/about' ? '/' : '/about', search: `?lang=${lang}` }} className={classes.link}>
              {location.pathname === '/about' ? `< ${lang === 'jp' ? data.jp.header.linkViz : data.en.header.linkViz}` : `${lang === 'jp' ? data.jp.header.linkAbout : data.en.header.linkAbout}`}
            </Link>
          </nav>
        </Box>
      </Container>
    </Box>
  );
};

Header.propTypes = {
  handleLangChange: PropTypes.func.isRequired,
  lang: PropTypes.string,
};

Header.defaultProps = {
  lang: 'en',
};

export default Header;
